import { AgnesButton } from '@agnes/ui';

/**
 * Retry exibido sob os seletores de empresa quando a lista atribuída falha ao carregar.
 * Sem erro não renderiza nada.
 */
export function EmployerListRetryButton({
  error,
  onRetry,
  dataQa,
}: {
  error: string | null;
  onRetry: () => void;
  dataQa?: string;
}) {
  if (!error) return null;
  return (
    <AgnesButton variant="text" size="sm" dataQa={dataQa} onClick={onRetry}>
      Tentar carregar empresas novamente
    </AgnesButton>
  );
}
